import { useContext } from 'react'
import { ScheduledPlayerContext } from '../contexts'

export const useScheduledPlayerContext = () => useContext(ScheduledPlayerContext)
